import { Button } from '@crazyegginc/hatch';

import { useAuthContext, usePermissions, useManageSubscriptionPath } from '/src/hooks';
import { Paywall } from '/src/components/Paywall';

import { SupportLinks } from '/src/support';
import { isSemrush } from '/src/utils/semrush';
import { FEATURES } from '/src/features/_global/constants';

import InactivePNG from '@crazyegginc/hatch/dist/images/illustration-inactive.png';
import InactiveWebP from '@crazyegginc/hatch/dist/images/illustration-inactive.webp';
import { AppLink } from '/src/features/_global/components/AppLink';
import { SupportLink } from '/src/features/_global/components/SupportLink';

export function SubscriptionCancelledPaywall() {
  const { currentAccount } = useAuthContext();
  const isStripeUser = Boolean(currentAccount?.useStripe);
  const permissions = usePermissions();
  const subscriptionPath = useManageSubscriptionPath();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;

  return (
    <Paywall>
      <Paywall.Image webp={InactiveWebP} fallback={InactivePNG} width="128" />
      <Paywall.Title>Your Crazy Egg subscription is inactive</Paywall.Title>

      {canManageBilling ? (
        <>
          <Paywall.Body>Choose a plan and restart your subscription to access your reports.</Paywall.Body>
          <Button
            component={AppLink}
            to={subscriptionPath}
            target={isStripeUser ? '_blank' : '_self'}
            rel={isStripeUser ? 'noopener noreferrer' : undefined}
          >
            Choose a plan
          </Button>
        </>
      ) : (
        <>
          <Paywall.Body>
            To continue using Crazy Egg, contact your Account Owner &#40;{currentAccount.ownerEmail}&#41; to reactivate
            this subscription.
            <div className="mt-5">
              {isSemrush ? (
                <>
                  If you need help, please{' '}
                  <SupportLink className="text-link" href={SupportLinks.general.newSupportRequest}>
                    contact support
                  </SupportLink>
                  .
                </>
              ) : (
                <>
                  If you need help, email us at{' '}
                  <a className="text-link" href={`mailto:${SupportLinks.general.email}`}>
                    {SupportLinks.general.email}
                  </a>
                  .
                </>
              )}
            </div>
          </Paywall.Body>
          <Button component="a" href={`mailto:${currentAccount.ownerEmail}`}>
            Contact account owner
          </Button>
        </>
      )}
    </Paywall>
  );
}
